"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var clone = function (obj) { return JSON.parse(JSON.stringify(obj)); };
exports.default = clone;
